import {
  Segmented,
  SearchInput,
  Banner,
  WarningTriangleIcon,
} from "./v2";

// Agents-tab toolbar — V2 rebuild 1:1 from ARTBOARD-SPEC boards 1a/1b/1c
// (desktop) and 1l (mobile filter chips). Presentation only: segment +
// search state/handlers are the existing client-side filter wiring in
// AgencyProfile (FUNCTION-INVENTORY §2.2) — same props, same callbacks.
// The Licensed/Unlicensed split is an INTERNAL admin filter — the word
// "Unlicensed" appears only here, never on a card or public profile (2g).

// Mobile filter chip (board 1l): active = white on brand; inactive =
// white chip, border #DCE3EC.
const MobileChip = ({ active, label, count, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={`flex-none whitespace-nowrap rounded-full text-[12.5px] px-[13px] py-1.5 ${
      active
        ? "font-semibold text-white bg-[#2283FF] border-0"
        : "font-medium text-[#475569] bg-white border border-[#DCE3EC]"
    }`}
  >
    {label} {count}
  </button>
);

const AgentsToolbar = ({
  counts = { all: 0, licensed: 0, unlicensed: 0 },
  segment = "all",
  onSegment,
  search = "",
  onSearch,
  showSegments = true,
  matchCount = 0,
  isMobile = false,
}) => {
  const q = search.trim();
  const segmentItems = [
    { key: "all", label: "All", count: counts.all },
    { key: "licensed", label: "Licensed", count: counts.licensed },
    { key: "unlicensed", label: "Unlicensed", count: counts.unlicensed },
  ];

  return (
    <div className="px-6 pt-4">
      {isMobile ? (
        /* Board 1l: full-width search, then filter chip row (gap 8). */
        <div className="flex flex-col gap-3">
          <SearchInput
            mobile
            width="100%"
            value={search}
            onChange={onSearch}
            onClear={() => onSearch("")}
            placeholder="Search by name or email"
            clearTitle="Clear search"
          />
          {showSegments && (
            <div className="flex gap-2 flex-wrap">
              {segmentItems.map((it) => (
                <MobileChip
                  key={it.key}
                  active={segment === it.key}
                  label={it.label}
                  count={it.count}
                  onClick={() => onSegment(it.key)}
                />
              ))}
            </div>
          )}
        </div>
      ) : (
        /* Boards 1a/1b: CMP-SEG (dimmed during active search) + CMP-SEARCH
           280px. */
        <div className="flex items-center justify-between gap-4 flex-wrap">
          {showSegments ? (
            <Segmented
              items={segmentItems}
              activeKey={segment}
              onChange={onSegment}
              dimmed={Boolean(q)}
            />
          ) : (
            <span />
          )}
          <SearchInput
            value={search}
            onChange={onSearch}
            onClear={() => onSearch("")}
            placeholder="Search by name or email"
            clearTitle="Clear search"
          />
        </div>
      )}

      {/* Board 1b: live result meta row — "N agent(s) match(es) “q”" +
          Clear search link. Count comes from the existing client-side
          filter (visibleAgents), never recomputed here. */}
      {q && (
        <div className="flex items-baseline gap-2.5" style={{ marginTop: 18 }}>
          <span className="text-[13px] text-[#64748B]">
            <span data-no-translate>{matchCount} </span>
            {matchCount === 1 ? "agent matches" : "agents match"}
            <span data-no-translate>
              {" “"}
              <b className="text-[#0F172A]">{q}</b>
              {"”"}
            </span>
          </span>
          <button
            type="button"
            onClick={() => onSearch("")}
            className="text-[13px] font-semibold text-[#1668D9] bg-transparent border-0 cursor-pointer p-0"
          >
            Clear search
          </button>
        </div>
      )}

      {/* Board 1c: unlicensed-filter context banner (admin-internal). */}
      {showSegments && segment === "unlicensed" && !q && (
        <Banner
          variant="warning"
          icon={<WarningTriangleIcon size={16} style={{ flex: "none" }} />}
          style={{ marginTop: 16 }}
        >
          Unlicensed agents can manage players but can’t sign request
          agreements on TransferPitch. Ask them to add their license in
          profile settings.
        </Banner>
      )}
    </div>
  );
};

export default AgentsToolbar;
